import React from "react";
import Search from './Search';
import QuickSearch from './QuickSearch';
import Strap from "./Strap";
import Featured from './Featured'
import Bestofmonth from './Bestofmonth'
import Banner from "./Banner";
import Review from "./Review";
import News from "./News";
import Header from "../../Header";
const Home = (Props) => {
    return (

        <React.Fragment>
            <Header />
            <Search />
            <Strap />
            <QuickSearch />
            <Banner />
            <Featured />
            <Bestofmonth />
            <Review />
            <News />
        </React.Fragment>
    )
}

export default Home;